import React from "react";
import { FormLayout, Modal, Select, SelectOption } from "@shopify/polaris";
import { useIndices } from "@usereactify/search";
import { useAppContext } from "~/providers/app";

export const ModalIndices = () => {
  const { showModalIndices, setShowModalIndices, shop, index, setIndex } = useAppContext();
  const shopName = shop.replace(".myshopify.com", "");
  const indicesHook = useIndices();

  const options = React.useMemo<Array<SelectOption>>(() => {
    return [
      {
        label: `Public (alias)`,
        value: `${shopName}-primary`,
      },
      ...indicesHook.indices.map((item, index) => ({
        label: indicesHook.indexNameFormat(item).replace(shopName, index === 0 ? "Latest" : "Historical"),
        value: item,
      })),
    ];
  }, [indicesHook.indices]);

  return (
    <Modal title="Change index" open={showModalIndices} onClose={() => setShowModalIndices(false)}>
      <Modal.Section>
        <FormLayout>
          <Select
            label="Index"
            labelHidden
            placeholder="Select an index"
            options={options}
            value={index}
            onChange={(value) => setIndex(value)}
          />
        </FormLayout>
      </Modal.Section>
    </Modal>
  );
};
